import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.0039 2.98138V11.9982M17.6928 7.1291C18.8098 8.26261 19.5709 9.70625 19.8802 11.278C20.1894 12.8497 20.0329 14.4791 19.4304 15.9607C18.828 17.4424 17.8065 18.7099 16.4948 19.6033C15.1831 20.4968 13.64 20.9763 12.06 20.9813C10.48 20.9864 8.93392 20.5167 7.61674 19.6316C6.29956 18.7464 5.27025 17.4854 4.65863 16.0077C4.04701 14.5299 3.88046 12.9015 4.17999 11.3279C4.47951 9.7542 5.23171 8.30575 6.3417 7.16517",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgIo);
export { ForwardRef as ReactComponent };
